import React, { useEffect, useState } from 'react'
import WhatsappButton from '../tools/WhatsappButton'
import { useParams } from 'react-router-dom'
import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore'
import { db } from '../../firebaseConfig/firebase'
import ProductModal from './ProductModal'

const ProductsShow = ({
    pWhatsAppPhoneNumber,
    pWhatsAppDefaultText,
    products
}) => {
    const { Category } = useParams()
    const location = window.location.origin

    const [productsList, setProductsList] = useState([])
    const [product, setProduct] = useState(null)
    const [whatsAppPhoneNumber, setWhatsAppPhoneNumber] = useState("")
    const [whatsAppDefaultText, setWhatsAppDefaultText] = useState("")
    const [shippingPrice, setShippingPrice] = useState(0)

    const getGeneralParameters = async () => {
        await getWhatsAppPhoneNumber()
        await getWhatsAppDefaultText()
        await getShippingPrice()
    }

    const getWhatsAppPhoneNumber = async () => {
        if (whatsAppPhoneNumber === "") {
            const whatsAppPhoneNumberQuery = query(collection(db, "parameters"), where("code", "==", "whatsAppPhoneNumber"));
            const whatsAppPhoneNumberDocs = await getDocs(whatsAppPhoneNumberQuery)
            if (whatsAppPhoneNumberDocs.docs.length > 0) {
                setWhatsAppPhoneNumber(whatsAppPhoneNumberDocs.docs[0].data().value)
            }
        }
    }

    const getWhatsAppDefaultText = async () => {
        if (whatsAppDefaultText === "") {
            const whatsAppDefaultTextQuery = query(collection(db, "parameters"), where("code", "==", "whatsAppDefaultText"));
            const whatsAppDefaultTextDocs = await getDocs(whatsAppDefaultTextQuery)
            if (whatsAppDefaultTextDocs.docs.length > 0) {
                setWhatsAppDefaultText(whatsAppDefaultTextDocs.docs[0].data().value)
            }
        }
    }

    const getShippingPrice = async () => {
        if (shippingPrice === 0) {
            const shippingPriceQuery = query(collection(db, "parameters"), where("code", "==", "ShippingPrice"));
            const shippingPriceDocs = await getDocs(shippingPriceQuery)
            if (shippingPriceDocs.docs.length > 0) {
                setShippingPrice(shippingPriceDocs.docs[0].data().value)
            }
        }
    }

    const getProductsIndex = async () => {
        if (productsList.length === 0) {
            const productsIndexQuery = query(collection(db, "indexes"), where("code", "==", "productsIndex"));
            const productsIndexDocs = await getDocs(productsIndexQuery)
            if (productsIndexDocs.docs.length > 0) {
                const productsFiltered = productsIndexDocs.docs[0].data().value
                    .filter(
                        item =>
                            item.productState === true &&
                            item.productCategories.includes(Category)
                    )
                    .sort((a, b) => a.productName.localeCompare(b.productName))

                setProductsList(
                    productsFiltered
                )
            } else {
                setProductsList([])
            }
        }
    }

    const SelectProduct = async function (productId) {
        const ref = await doc(db, 'products', productId)
        const productDoc = await getDoc(ref)
        if (productDoc.exists) {
            setProduct({ id: productDoc.id, ...productDoc.data()});
        } else {
            console.log("Producto no encontrado");
        }
    }

    useEffect(() => {
        if (products && products.length > 0) {
            setProductsList(products)
            setWhatsAppPhoneNumber(pWhatsAppPhoneNumber)
            setWhatsAppDefaultText(pWhatsAppDefaultText)
            getShippingPrice()
        } else if (Category) {
            getGeneralParameters()
            getProductsIndex()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [products, pWhatsAppPhoneNumber, pWhatsAppDefaultText])

    return (
        <>
            {productsList.length > 0 ? (
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="m-2 row">
                                <div className="col-12">
                                    <h1>Productos</h1>
                                </div>
                            </div>
                            <div className='row'>
                                {
                                    productsList.map((product) => (
                                        <div className='col col-6 col-sm-6 col-lg-4' key={product.productId}>
                                            <div className="m-1 p-1" onClick={() => SelectProduct(product.productId)}>
                                                <div data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                                    <img style={{ width: 157.5, height: 157.5 }} src={product.productImage} alt={product.productName} />
                                                    <h4>{product.productBrand} {product.productName}</h4>
                                                    <h6>{product.productPrice > 0 ? "₡" + product.productPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : "Cotizar"}</h6>
                                                </div>
                                                <div className="text-end">
                                                    <WhatsappButton text={`${whatsAppDefaultText} ${product.productBrand} ${product.productName} ${location}/Product/${product.productId}`} whatsAppPhoneNumber={whatsAppPhoneNumber} />
                                                </div>
                                                <span>{product.brand}</span>
                                            </div>
                                        </div>
                                    )
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <ProductModal
                        pProduct={product}
                        pWhatsAppDefaultText={whatsAppDefaultText}
                        pWhatsAppPhoneNumber={whatsAppPhoneNumber}
                        pShippingPrice={shippingPrice}
                    />
                </div>
            ) : (<></>)}
        </>
    )
}

export default ProductsShow